import React, { CSSProperties, ReactNode } from 'react'
import classNames from 'classnames'
import {
  BASE_CLASSES,
  BorderRadius,
  ICON_BUTTON_VARIANT_CLASSES,
  IconButtonIconSize,
  IconButtonSize,
  iconButtonSize,
  IconButtonVariant,
  iconSizes,
} from './constants'
import { Icon } from '@slite/icons'

export type BaseIconButtonProps = {
  icon: Icon
  className?: string
  style?: CSSProperties
  variant?: IconButtonVariant
  size?: IconButtonSize
  isActive?: boolean
  disabled?: boolean
  disableFocus?: boolean
  iconSize?: IconButtonIconSize
  iconClassname?: string
  iconStyle?: CSSProperties
  borderRadius?: BorderRadius
  children: (props: {
    className: string
    style: CSSProperties
    children: ReactNode
  }) => ReactNode
}

export const BaseIconButton = ({
  className,
  style,
  variant = 'primary',
  size = 'medium',
  isActive = false,
  disabled = false,
  disableFocus,
  icon: IconComponent,
  iconClassname,
  iconSize = 'large',
  iconStyle,
  borderRadius,
  children: render,
}: BaseIconButtonProps) => {
  const computedClassname = classNames(
    BASE_CLASSES,
    borderRadius ?? size === 'smaller' ? 'radius-normal' : 'radius-large',
    [ICON_BUTTON_VARIANT_CLASSES[variant]['base']],
    {
      'extra-white-outline-on-focus': !disableFocus && size !== 'smaller',
      // default
      pointer: !disabled,
      [ICON_BUTTON_VARIANT_CLASSES[variant]['default']]: !disabled && !isActive,

      // isActive
      [ICON_BUTTON_VARIANT_CLASSES[variant]['isActive']]: isActive && !disabled,

      // disabled
      [ICON_BUTTON_VARIANT_CLASSES[variant]['disabled']]:
        disabled && !isActive && !isActive,
    },
    className
  )
  const computedStyle = {
    width: iconButtonSize[size],
    height: iconButtonSize[size],
    ...style,
  }
  return (
    <>
      {render({
        className: computedClassname,
        style: computedStyle,
        children: (
          <IconComponent
            className={iconClassname}
            size={iconSizes[iconSize]}
            style={iconStyle}
          />
        ),
      })}
    </>
  )
}
